/**
 * QuantitySelector — Reusable standalone quantity input component
 * Works for both cart items and PDP quantity selectors
 * Dispatches custom events for external listeners
 */

(function () {
  'use strict';

  class QuantitySelector extends HTMLElement {
    connectedCallback() {
      this._input  = this.querySelector('[data-qty-input]');
      this._decBtn = this.querySelector('[data-action="decrease"]');
      this._incBtn = this.querySelector('[data-action="increase"]');
      this._min    = parseInt(this.dataset.min || '0', 10);
      this._max    = parseInt(this.dataset.max || '99', 10);

      this._decBtn?.addEventListener('click', () => this._step(-1));
      this._incBtn?.addEventListener('click', () => this._step(1));

      this._input?.addEventListener('change', () => {
        const val = Math.min(
          this._max,
          Math.max(this._min, parseInt(this._input.value, 10) || this._min)
        );
        this._input.value = val;
        this._dispatch(val);
      });
    }

    _step(direction) {
      const current = parseInt(this._input?.value || '1', 10);
      const next = Math.min(this._max, Math.max(this._min, current + direction));
      if (this._input) this._input.value = next;
      this._dispatch(next);
    }

    _dispatch(value) {
      this.dispatchEvent(
        new CustomEvent('quantity:change', {
          bubbles: true,
          detail: { value, key: this.dataset.key }
        })
      );
    }
  }

  if (!customElements.get('quantity-selector')) {
    customElements.define('quantity-selector', QuantitySelector);
  }
})();
